import Vue from 'vue';
import VueKuzzle from 'vue-plugin-kuzzle';
//import VueKuzzle from 'vue-kuzzle';
import DatetimePicker from 'vuetify-datetime-picker';
import 'vuetify-datetime-picker/src/stylus/main.styl';
import App from './App.vue';
import { createRouter } from './router';
import store from './store';
import i18n from './i18n';
import './notifications';
import config from './config.json';
import './plugins';
import AppIcons from './plugins/AppIcons';
import Draggable from 'vuedraggable';
import ImageUploader from 'vue-image-upload-resize';
import VueFlags from '@growthbunker/vueflags';
import Lottie from 'vue-lottie';
import { version } from '../package.json';
Vue.config.productionTip = false;

Vue.use(VueKuzzle, config);
Vue.use(AppIcons);
Vue.use(DatetimePicker);
Vue.use(Draggable);
Vue.use(ImageUploader);
Vue.use(VueFlags, { iconPath: '/images/' });
Vue.use(Lottie);
//Vue.use(VueResizable);

console.log('studio version', version);

const router = createRouter(Vue.prototype.$kuzzle, i18n, store);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
